import { createElement } from 'react';
import { Box, Select, Button, Icon } from '@alifd/next';
import ConditionItem from './condition-item';
const ConditionGroup = ({ condition, attributeDataSource, onAdd, onRemove, onChange, handleButtonClick }) => {
    console.log('ConditionGroup render condition', condition);
    const { value = [], operator = 'and', id } = condition;
    return (createElement(Box, { direction: "row", align: "center", justify: "left" },
        createElement(Box, { direction: "row", align: "center", justify: "left" },
            createElement(Select, { value: operator, onChange: v => onChange(id, { operator: v }), autoWidth: false },
                createElement(Select.Option, { value: "and" }, "\u5E76\u4E14"),
                createElement(Select.Option, { value: "or" }, "\u6216\u8005"))),
        Array.isArray(value) && value.map((item) => (createElement(ConditionItem, { condition: item, parentId: id, attributeDataSource: attributeDataSource, onAdd: onAdd, onRemove: onRemove, onChange: onChange }))),
        createElement(Box, { direction: 'row', align: "center", justify: "left", spacing: 10, margin: 2, padding: 2 },
            createElement(Button, { className: "add-button", onClick: () => onAdd(id, false) },
                createElement(Icon, { type: "add", size: "xs" })))));
};
export default ConditionGroup;
